import { requestApi } from "~/api/requestApi";
import type { TInventory } from "../type/TInventory";

export async function apiInventoryGet() {
  const data = await requestApi({
    endpoint: "inventory/v2/me/inventory",
    method: "get",
  });

  return data as TInventory;
}
